import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Demo from './pages/Demo';
import Dashboard from './pages/Dashboard';
import DashboardOld from './pages/DashboardOld';
import CreateAlarm from './pages/CreateAlarm';
import EditAlarm from './pages/EditAlarm';
import PaymentSetup from './pages/PaymentSetup';
import AlarmVisualization from './pages/AlarmVisualization';
import ManageLocations from './pages/ManageLocations';
import CreateLocation from './pages/CreateLocation';
import EditLocation from './pages/EditLocation';
import ManageContacts from './pages/ManageContacts';
import ContactConsent from './pages/ContactConsent';
import ManagePledges from './pages/ManagePledges';
import Settings from './pages/Settings';
import RunPledge from './pages/RunPledge';
import PledgeHistory from './pages/PledgeHistory';
import Faq from './pages/Faq';
import NameOnboardingPrompt from './components/NameOnboardingPrompt';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #111827;
`;

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {children}
      <NameOnboardingPrompt />
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContainer>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/demo/dashboard" element={<Navigate to="/dashboard" replace />} />
            <Route path="/contacts/consent/:token" element={<ContactConsent />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard-old"
              element={
                <PrivateRoute>
                  <DashboardOld />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-alarm"
              element={
                <PrivateRoute>
                  <CreateAlarm />
                </PrivateRoute>
              }
            />
            <Route
              path="/alarms/:alarmId/edit"
              element={
                <PrivateRoute>
                  <EditAlarm />
                </PrivateRoute>
              }
            />
            <Route
              path="/payment-setup"
              element={
                <PrivateRoute>
                  <PaymentSetup />
                </PrivateRoute>
              }
            />
            <Route
              path="/visualization"
              element={
                <PrivateRoute>
                  <AlarmVisualization />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-locations"
              element={
                <PrivateRoute>
                  <ManageLocations />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-locations/new"
              element={
                <PrivateRoute>
                  <CreateLocation />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-locations/:locationId/edit"
              element={
                <PrivateRoute>
                  <EditLocation />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-contacts"
              element={
                <PrivateRoute>
                  <ManageContacts />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-pledges"
              element={
                <PrivateRoute>
                  <ManagePledges />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/run-pledge"
              element={
                <PrivateRoute>
                  <RunPledge />
                </PrivateRoute>
              }
            />
            <Route
              path="/pledge-history"
              element={
                <PrivateRoute>
                  <PledgeHistory />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </AppContainer>
      </Router>
    </AuthProvider>
  );
};

export default App;
